import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gavel } from "lucide-react";
import { apiClient } from "../lib/api";
import { useI18n } from "../lib/i18n";

/**
 * A small red, flashing badge that ONLY renders when at least one auction
 * is currently live. Placed near the top of the Hero to grab immediate
 * attention. Hides itself completely (returns null) when there is no
 * active auction.
 */
export default function LiveAuctionAlertBadge() {
  const { lang } = useI18n();
  const [count, setCount] = useState(0);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchLive = () => {
      apiClient
        .get("/auctions/live", { params: { limit: 20 } })
        .then(({ data }) => {
          if (!cancelled) setCount((data.items || []).length);
        })
        .catch(() => {
          if (!cancelled) setCount(0);
        })
        .finally(() => {
          if (!cancelled) setReady(true);
        });
    };
    fetchLive();
    const tm = setInterval(fetchLive, 30000); // refresh every 30s
    return () => {
      cancelled = true;
      clearInterval(tm);
    };
  }, []);

  if (!ready || count <= 0) return null;

  return (
    <Link
      to="/auctions"
      data-testid="live-auctions-alert-badge"
      className="group inline-flex items-center gap-2 rounded-full ps-2 pe-4 py-1.5 text-[12px] sm:text-[13px] font-extrabold uppercase tracking-widest text-white shadow-lg animate-pulse hover:animate-none hover:scale-105 transition-transform mb-4"
      style={{ background: "linear-gradient(135deg,#dc2626,#9f1239)" }}
    >
      <span className="relative flex items-center justify-center w-6 h-6 rounded-full bg-white/20">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-30 animate-ping" />
        <Gavel className="w-3.5 h-3.5 relative" />
      </span>
      <span className="flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
        {lang === "ar" ? `مزادات مباشرة الآن · ${count}` : `Live auctions now · ${count}`}
      </span>
    </Link>
  );
}
